import { Pipe, PipeTransform } from '@angular/core';
import { fadeInItems } from '@angular/material/menu';
import { DualListBoxItem } from '../../components/shared-components/dual-list-box/dual-list-box.component';

@Pipe({
  name: 'orderByName',
  pure: false
})
export class OrderByNamePipe implements PipeTransform {

  transform(items: DualListBoxItem[]): DualListBoxItem[] {
    return items.sort(
      (a, b) => {
        return a[0] - b[0];
      }
    );
  }

}
